export default "__VITE_ASSET__C4o1o_nS__"